import { useMemo } from 'react';
import { FieldMessage, FieldMessageType } from '@shipengine/giger';
import { ParcelFieldFields } from './ParcelField.js';
import { getWrapperStyles } from './DimensionFieldMessageStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';

const DimensionFieldMessage = _ref => {
  let {
    errors,
    touched
  } = _ref;
  const errorsToShow = useMemo(() => {
    return errors ? Object.keys(errors).filter(errorKey => errorKey !== ParcelFieldFields.FIELD_WEIGHT && !!errors[errorKey] && !!(touched !== null && touched !== void 0 && touched[errorKey])).map(errorKey => ({
      id: errorKey,
      message: errors[errorKey]
    })) : [];
  }, [errors, touched]);
  return jsx("div", {
    css: getWrapperStyles,
    children: errorsToShow && errorsToShow.map(_ref2 => {
      let {
        message,
        id
      } = _ref2;
      return jsx(FieldMessage, {
        type: FieldMessageType.ERROR,
        children: message
      }, id);
    })
  });
};

export { DimensionFieldMessage };
//# sourceMappingURL=DimensionFieldMessage.js.map
